import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function Settings() {
  const [addressTypes, setAddressTypes] = useState([]);
  const [governmentIdTypes, setGovernmentIdTypes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [newAddressType, setNewAddressType] = useState('');
  const [newGovernmentIdType, setNewGovernmentIdType] = useState('');
  const [newDepartment, setNewDepartment] = useState('');
  const [cfForm, setCfForm] = useState(null);
  const [holidayForm, setHolidayForm] = useState(null);

  const loadAddressTypes = () => api(`/hcm/employee-address-types`).then(r => r.json()).then(setAddressTypes).catch(() => {});
  const loadGovernmentIdTypes = () => api(`/hcm/employee-government-id-types`).then(r => r.json()).then(setGovernmentIdTypes).catch(() => {});
  const loadDepartments = () => api(`/hcm/departments`).then(r => r.json()).then(setDepartments).catch(() => {});
  const loadCustomFields = () => api(`/hcm/custom-fields`).then(r => r.json()).then(setCustomFields).catch(() => {});
  const loadHolidays = () => api(`/hcm/holidays`).then(r => r.json()).then(setHolidays).catch(() => {});

  useEffect(() => { 
    loadAddressTypes();
    loadGovernmentIdTypes();
    loadDepartments();
    loadCustomFields();
    loadHolidays();
  }, []);

  const handleAddAddressType = async (e) => {
    e.preventDefault();
    if (!newAddressType.trim()) return;
    await api(`/hcm/employee-address-types`, { method: 'POST', body: JSON.stringify({ name: newAddressType.trim() }) });
    setNewAddressType('');
    loadAddressTypes();
  };

  const handleDeleteAddressType = async (id) => {
    await api(`/hcm/employee-address-types/${id}`, { method: 'DELETE' });
    loadAddressTypes();
  };

  const handleAddGovernmentIdType = async (e) => {
    e.preventDefault();
    if (!newGovernmentIdType.trim()) return;
    await api(`/hcm/employee-government-id-types`, { method: 'POST', body: JSON.stringify({ name: newGovernmentIdType.trim() }) });
    setNewGovernmentIdType('');
    loadGovernmentIdTypes();
  };

  const handleDeleteGovernmentIdType = async (id) => {
    await api(`/hcm/employee-government-id-types/${id}`, { method: 'DELETE' });
    loadGovernmentIdTypes();
  };

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b">
          <h1 className="text-2xl font-bold text-gray-900">HCM Settings</h1>
        </div>
        <div className="p-4 md:p-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Address Types Section */}
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Address Types</h2>
              <form onSubmit={handleAddAddressType} className="flex gap-3 mb-6">
                <input type="text" placeholder="New address type..." value={newAddressType} onChange={(e) => setNewAddressType(e.target.value)}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600" />
                <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Add</button>
              </form>
              <ul className="divide-y divide-gray-200">
                {addressTypes.map((t) => (
                  <li key={t.id} className="flex items-center justify-between py-3">
                    <span className="text-gray-900">{t.name}</span>
                    <button onClick={() => handleDeleteAddressType(t.id)} className="text-red-600 hover:text-red-800 text-sm font-medium">Remove</button>
                  </li>
                ))}
              </ul>
              {addressTypes.length === 0 && <p className="text-gray-500 text-center py-4">No address types defined yet.</p>}
            </div>

            {/* Government ID Types Section */}
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Government ID Types</h2>
              <form onSubmit={handleAddGovernmentIdType} className="flex gap-3 mb-6">
                <input type="text" placeholder="New government ID type..." value={newGovernmentIdType} onChange={(e) => setNewGovernmentIdType(e.target.value)}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600" />
                <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Add</button>
              </form>
              <ul className="divide-y divide-gray-200">
                {governmentIdTypes.map((t) => (
                  <li key={t.id} className="flex items-center justify-between py-3">
                    <span className="text-gray-900">{t.name}</span>
                    <button onClick={() => handleDeleteGovernmentIdType(t.id)} className="text-red-600 hover:text-red-800 text-sm font-medium">Remove</button>
                  </li>
                ))}
              </ul>
              {governmentIdTypes.length === 0 && <p className="text-gray-500 text-center py-4">No government ID types defined yet.</p>}
            </div>

            {/* Departments Section */}
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Departments</h2>
              <form onSubmit={async (e) => { e.preventDefault(); if (!newDepartment.trim()) return; await api(`/hcm/departments`, { method: 'POST', body: JSON.stringify({ name: newDepartment.trim() }) }); setNewDepartment(''); loadDepartments(); }} className="flex gap-3 mb-6">
                <input type="text" placeholder="New department..." value={newDepartment} onChange={(e) => setNewDepartment(e.target.value)}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600" />
                <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Add</button>
              </form>
              <ul className="divide-y divide-gray-200">
                {departments.map((t) => (
                  <li key={t.id} className="flex items-center justify-between py-3">
                    <span className="text-gray-900">{t.name}</span>
                    <button onClick={async () => { await api(`/hcm/departments/${t.id}`, { method: 'DELETE' }); loadDepartments(); }} className="text-red-600 hover:text-red-800 text-sm font-medium">Remove</button>
                  </li>
                ))}
              </ul>
              {departments.length === 0 && <p className="text-gray-500 text-center py-4">No departments defined yet.</p>}
            </div>
          </div>

          {/* Holidays Section */}
          <div className="mt-8">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Company Holidays</h2>
            <div className="flex justify-end mb-4">
              <button onClick={() => setHolidayForm({name: '', date: '', recurring: false})} className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm">Add Holiday</button>
            </div>
            <div className="divide-y divide-gray-200">
              {holidays.map(h => (
                <div key={h.id} className="flex items-center justify-between py-3">
                  <div>
                    <span className="text-gray-900 font-medium">{h.name}</span>
                    <span className="text-sm text-gray-500 ml-2">{h.date}</span>
                    {h.recurring && <span className="text-xs text-indigo-600 ml-2">Recurring</span>}
                  </div>
                  <div className="flex gap-2">
                    <button onClick={() => setHolidayForm({id: h.id, name: h.name, date: h.date, recurring: h.recurring})} className="text-gray-500 hover:text-indigo-600 text-sm font-medium">Edit</button>
                    <button onClick={async () => { await api(`/hcm/holidays/${h.id}`, {method: 'DELETE'}); loadHolidays(); }} className="text-red-600 hover:text-red-800 text-sm font-medium">Remove</button>
                  </div>
                </div>
              ))}
            </div>
            {holidays.length === 0 && <p className="text-gray-500 text-center py-4">No holidays defined yet.</p>}
          </div>

          {/* Custom Fields Section */}
          <div className="mt-8">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Custom Employee Fields</h2>
            <div className="flex justify-end mb-4">
              <button onClick={() => setCfForm({name: '', fieldType: 'text', options: '', required: false})} className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm">Add Field</button>
            </div>
            <div className="divide-y divide-gray-200">
              {customFields.map(f => (
                <div key={f.id} className="flex items-center justify-between py-3">
                  <div>
                    <span className="text-gray-900 font-medium">{f.name}</span>
                    <span className="text-xs text-gray-500 ml-2">({f.fieldType})</span>
                    {f.required && <span className="text-xs text-red-500 ml-1">required</span>}
                  </div>
                  <button onClick={async () => { await api(`/hcm/custom-fields/${f.id}`, {method: 'DELETE'}); loadCustomFields(); }} className="text-red-600 hover:text-red-800 text-sm font-medium">Remove</button>
                </div>
              ))}
            </div>
            {customFields.length === 0 && <p className="text-gray-500 text-center py-4">No custom fields defined yet.</p>}
          </div>
        </div>
      </div>

      {cfForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setCfForm(null)}>
          <form onSubmit={async e => { e.preventDefault(); await api('/hcm/custom-fields', {method: 'POST', body: JSON.stringify(cfForm)}); setCfForm(null); loadCustomFields(); }} onClick={e => e.stopPropagation()} className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md space-y-4">
            <h3 className="text-lg font-semibold text-gray-900">Add Custom Field</h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
              <input required value={cfForm.name} onChange={e => setCfForm({...cfForm, name: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
              <select value={cfForm.fieldType} onChange={e => setCfForm({...cfForm, fieldType: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                <option value="text">Text</option>
                <option value="number">Number</option>
                <option value="date">Date</option>
                <option value="select">Dropdown</option>
              </select>
            </div>
            {cfForm.fieldType === 'select' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Options (comma-separated)</label>
                <input value={cfForm.options} onChange={e => setCfForm({...cfForm, options: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" placeholder="Option 1, Option 2" />
              </div>
            )}
            <label className="flex items-center gap-2">
              <input type="checkbox" checked={cfForm.required} onChange={e => setCfForm({...cfForm, required: e.target.checked})} className="rounded" />
              <span className="text-sm text-gray-700">Required</span>
            </label>
            <div className="flex justify-end gap-3">
              <button type="button" onClick={() => setCfForm(null)} className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Cancel</button>
              <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Create</button>
            </div>
          </form>
        </div>
      )}

      {holidayForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setHolidayForm(null)}>
          <form onSubmit={async e => {
            e.preventDefault();
            if (holidayForm.id) {
              await api(`/hcm/holidays/${holidayForm.id}`, {method: 'PUT', body: JSON.stringify({name: holidayForm.name, date: holidayForm.date, recurring: holidayForm.recurring})});
            } else {
              await api('/hcm/holidays', {method: 'POST', body: JSON.stringify(holidayForm)});
            }
            setHolidayForm(null); loadHolidays();
          }} onClick={e => e.stopPropagation()} className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md space-y-4">
            <h3 className="text-lg font-semibold text-gray-900">{holidayForm.id ? 'Edit' : 'Add'} Holiday</h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
              <input required value={holidayForm.name} onChange={e => setHolidayForm({...holidayForm, name: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" placeholder="e.g. New Year's Day" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date *</label>
              <input type="date" required value={holidayForm.date} onChange={e => setHolidayForm({...holidayForm, date: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
            </div>
            <label className="flex items-center gap-2">
              <input type="checkbox" checked={holidayForm.recurring} onChange={e => setHolidayForm({...holidayForm, recurring: e.target.checked})} className="rounded" />
              <span className="text-sm text-gray-700">Repeats every year</span>
            </label>
            <div className="flex justify-end gap-3">
              <button type="button" onClick={() => setHolidayForm(null)} className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Cancel</button>
              <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">{holidayForm.id ? 'Save' : 'Create'}</button>
            </div>
          </form>
        </div>
      )}
    </Layout>
  );
}
